import type { TitleCard } from '@dmp/qqms/types';

export const defaultTitleCard: TitleCard = {
    id: '',
    type: 'titleCard',
    body: 'Please take our amazing survey!',
    traxexLabel: 'TitleCard',
    buttonCopy: 'Start Survey',
    resultCard: undefined,
};
